import { TabbedItemPage } from './TabbedItemPage';

export const LeavePage = () => <TabbedItemPage itemPath="/maintenance/leave" />;
